import { formatDayMonth } from "../../../utils/directorFormat";

const SCENARIO_LABELS = { conservative: "Conservador", stress: "Estresse" };

// Avisos que mudam a leitura (spec `director/workspace-navigation`): ficam junto da resposta,
// não só no rodapé. Dados bloqueados, escopo parcial e cenário diferente do base.
const readingWarnings = ({ refreshStatus = null, access = null, scenario = "base" } = {}) => {
  const warnings = [];
  if (refreshStatus?.state === "blocked") {
    const day = formatDayMonth(refreshStatus.dataBusinessDate || refreshStatus.dataAsOf);
    warnings.push(`Dados bloqueados: a última atualização não publicou${day ? `, e os números são de ${day}` : ""}.`);
  }
  if (access?.completePortfolioScope === false) {
    warnings.push("Escopo parcial: os números somam só as obras que você enxerga.");
  }
  if (scenario && scenario !== "base") {
    warnings.push(`Cenário ${SCENARIO_LABELS[scenario] || scenario}: os números não são os do cenário base.`);
  }
  return warnings;
};

export default readingWarnings;
